import { DependencyList, useLayoutEffect, useMemo } from 'react';

export type Disposable = {
    dispose: () => void;
};

export const useMemoDisposable = <T extends Disposable | null | undefined>(
    factory: () => T,
    deps: DependencyList
): T => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const result = useMemo(factory, deps);

    useLayoutEffect(() => {
        if (result !== null && result !== undefined) {
            return () => {
                result.dispose();
            };
        }
    }, [result]);

    return result;
};
